var map = {
	"./comment-plus.svg": "0a0f",
	"./delete.svg": "0d45",
	"./edit.svg": "daf0",
	"./icon-列表.svg": "747d",
	"./icon-前往.svg": "83f9",
	"./icon-反馈.svg": "1284",
	"./icon-新对话.svg": "3a4c",
	"./menu.svg": "d17f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";